import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader.jsx";
import { toast } from "react-toastify";
import { updateUserProfile } from "../Common/apis.js";
import Aos from "aos";

const MyProfile = ({userData, setUserData, fetchUserProfile }) => {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);

  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateProfile = async () => {
    setLoading(true);
    try {
      await updateUserProfile(userData); // API Call
      toast.success("Profile updated successfully!");
      setEditing(false);
    } catch (error) {
      toast.error("Failed to update profile!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-info">
      {loading && <Loader />}
      <div className="profile-info-heading pb-[37px]">
        <h3 data-aos="fade-right">My Profile</h3>
        <button data-aos="fade-left" onClick={() => setEditing(!editing)}>
          {editing ? "Cancel" : "Edit"}
        </button>
      </div>
      <div className="flex flex-col gap-[24px] overflow-hidden">
      <div className="profile-info-ips">
        <div className="profile-info-ip">
          <label data-aos="fade-right">Full Name</label>
          <input
          data-aos="fade-left"
            name="name"
            placeholder="Your Name"
            value={userData?.name}
            onChange={handleChange}
            disabled={!editing}
          />
        </div>
      </div>
      <div className="profile-info-ips">
        <div className="profile-info-ip">
          <label data-aos="fade-right">Email</label>
          <input
          data-aos="fade-left"
            name="email"
            placeholder="Your Email"
            value={userData?.email}
            onChange={handleChange}
            disabled={!editing}
          />
        </div>
      </div>
      <div className="profile-info-ips">
        <div className="profile-info-ip">
          <label data-aos="fade-right">Phone</label>
          <input
          data-aos="fade-left"
            name="phone"
            placeholder="Your Phone Number"
            value={userData?.phone}
            onChange={handleChange}
            disabled={!editing}
          />
        </div>
      </div>
      </div>
      {editing && (
        <button onClick={handleUpdateProfile} disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </button>
      )}
      {/* <div className="profile-info-ips">
        <div className="profile-info-ip">
          <label>Full Name</label>
          <input placeholder="Your Name" />
        </div>
        <div className="profile-info-ip">
          <label>Full Name</label>
          <input placeholder="Your Name" />
        </div>
      </div>
      <br />
      <div className="profile-info-ips">
        <div className="profile-info-ip">
          <label>Full Name</label>
          <input placeholder="Your Name" />
        </div>
        <div className="profile-info-ip">
          <label>Full Name</label>
          <input placeholder="Your Name" />
        </div>
      </div>
      <br />
      <div className="profile-info-ips">
        <div className="profile-info-ip">
          <label>Full Name</label>
          <input placeholder="Your Name" />
        </div>
        <div className="profile-info-ip">
          <label>Full Name</label>
          <input placeholder="Your Name" />
        </div>
      </div>
      <br />
      <h3>My email Address</h3> */}
      <br />
    </div>
  );
};

export default MyProfile;
